import { extendTheme } from "@chakra-ui/react";

const colors = {
  primary: {
    50: "#fdfbf7",
    100: "#f7f2e8",
    200: "#eae0cc",
    300: "#decfa9",
    400: "#cfbd87",
    500: "#C1AA65", // Warm Antique Gold
    600: "#a38e50",
    700: "#857340",
    800: "#685931",
    900: "#4b4021",
  },
  accent: {
    500: "#C1AA65",
  },
};

const fonts = {
  heading: `'Kanit', sans-serif`,  // For headings
  body: `'Kanit', sans-serif`,     // For body text
};

// Extend the theme
export const theme = extendTheme({
  colors,
  fonts,
  // You can also customize component styles, fonts, etc. here
});
